import {
    Breadcrumb,
    Button,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    TimePicker,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../../redux/reducers";
import {
    BasicStateForListModel
} from "../../models";
//import { TemplateContent } from "./template.content"
import {
    AndroidFilled,
    AppleFilled, DeleteOutlined,
    DownOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    addTemplate,
    copyTemplates,
    deleteTemplate,
    getTemplate,
    getTemplateList,
    getTemplateTabs,
} from "../../../axios/api.device";
import { gaEvent } from "../../../withTracker";
import { TemplateAppRestriction } from "./template.appRestriction";
import { TemplateContentRestriction } from "./template.contenRestriction";
import { TemplateContentADCertificate } from "./template.contentADCertificate";
import { TemplateContentADDomain } from "./template.contentADDomain";
import { TemplateContentBook } from "./template.contentBook";
import { TemplateContentBrowse } from "./template.contentBrowse";
import { TemplateContentCertificate } from "./template.contentCertificate";
import { TemplateContentCustomConfig } from "./template.contentCustomConfig";
import { TemplateContentKernelExtension } from "./template.contentKernelExtension";
import { TemplateContentLDAP } from "./template.contentLDAP";
import { TemplateContentLock } from "./template.contentLock";
import { TemplateContentPassword } from "./template.contentPassword";
import { TemplatePrivacyPreferences } from "./template.contentPrivacyPreferences";
import { TemplateContentRecoveryLock } from "./template.contentRecoveryLock";
import { TimplateScreenLayout } from "./template.contentScreenLayout";
import { HomeScreenLayout } from "./template.contentScreenLayoutV2";
import { TemplateContentSingleApp } from "./template.contentSingleApp";
import { TemplateContentSystemExtension } from "./template.contentSystemExtension";
import { TemplateContentWallpaper } from "./template.contentWallpaper";
import { TemplateContentWebClip } from "./template.contentWebClip";
import { TemplateContentWifi } from "./template.contentWifi";
import { TemplateDeviceMode } from "./template.deviceMode";
import { TemplateContentHttpProxy } from "./template.contentHttpProxy";
import "./template.scss";

import { Translation } from "react-i18next";
import { TemplateContentDNSSetting } from "./template.contentDNSSetting";
import { TemplateContentLoginItem } from "./template.contentLoginItem";
import { TemplateConentSecurity } from "./template.contentSecurity";
import { TemplateConentLoginWindow } from "./template.contentLoginWindow";
import { TemplateContentVpn } from "./template.contentVpn";
import { TemplateContentMacWallpaper } from "./template.content.macWallpaper";
import { TemplateContentMacDiskManagement } from "./template.content.macDisk";
import { TemplateContentMacTimeMachine } from "./template.content.macTimeMachine";
import { TemplateContentAirPrint } from "./template.content.airPrint";
import { TemplateContentEnergySaver } from "./template.content.macEnergySaver";
import { TemplateContentDock } from "./template.content.macDock";

const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
// const MyIcon = createFromIconfontCN({
//     scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
// });
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    // showAddDeviceForTemplate: boolean,
    // devicesList: any[],
    selectDevices: any[],
    currentName: string,
    templateTabs: any[],
    dropdownVisible: any[],
    isModify: boolean,
    templateItemsStatus: any,
    templateItemsMap: any,
    isCustom: boolean,
    selectWeek: number,
    dayList: any[],
    worshipDays: any[],
    configFileType: string,
    isSelectdItem: boolean,
    templateSelectItemsMap: any,
    platform:string,
    brand:string
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class TemplateIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "TemplateIndex",
            current: "",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            selectRow: {},
            showRightBox: false,
            // showAddDeviceForTemplate: false,
            // devicesList: [],
            selectDevices: [],
            templateTabs: [],
            dropdownVisible: [],
            isModify: false,
            isSelectdItem: false,
            platform: "",
            brand:"",
            templateItemsStatus: {
                App: false,
                WebClip: false,
                Password: false,
                MultiAppsMode: false,
                WiFi: false,
                Restriction: false,
                WallPaper: false,
                LockScreen: false,
                WebFilter: false,
                AppRestriction: false,
                HomeScreenLayout: false,
                Cert: false,
                CustomConfig: false,
                Media: false,
                ADDomain: false,
                ADCertificate: false,
                SystemExtension: false,
                KernelExtension: false,
                RecoveryLock: false,
                PrivacyPreference: false,
                DeviceMode: false,
                LDAP: false,
                HttpProxy: false,
                DNSSetting: false,
                MacSecurity: false,
                MacLoginWindow: false,
                Vpn: false,
                MacWallpaper: false,
                MacDiskManagement: false,
                MacTimeMachine: false,
                AirPrint: false,
                Energy: false,
                Dock: false,
            },
            templateItemsMap: {
                Applications: "App",
                Webclip: "WebClip",
                Password: "Password",
                KioskMode: "MultiAppsMode",
                Network: "WiFi",
                restriction: "Restriction",
                Wallpapers: "WallPaper",
                LockScreen: "LockScreen",
                WebContent: "WebFilter",
                AppsRestrictions: "AppRestriction",
                HomeScreenLayout: "HomeScreenLayout",
                Certificate: "Cert",
                CustomConfig: "CustomConfig",
                Book: "Media",
                ADDomain: "ADDomain",
                ADCertificate: "ADCertificate",
                SystemExtension: "SystemExtension",
                KernelExtension: "KernelExtension",
                RecoveryLock: "RecoveryLock",
                PrivacyPreference: "PrivacyPreference",
                DeviceMode: "DeviceMode",
                LDAP: "LDAP",
                HttpProxy: "HttpProxy",
                DNSSetting: "DNSSetting",
                LoginItem: "LoginItem",
                MacSecurity: "MacSecurity",
                MacLoginWindow: "MacLoginWindow",
                Vpn: "Vpn",
                MacWallpaper: "MacWallpaper",
                MacDiskManagement: "MacDiskManagement",
                MacTimeMachine: "MacTimeMachine",
                AirPrint: "AirPrint",
                Energy: "Energy",
                Dock: "Dock",
            },
            templateSelectItemsMap: {
                App: "Applications",
                WebClip: "Webclip",
                Password: "Password",
                MultiAppsMode: "KioskMode",
                WiFi: "Network",
                Restriction: "restriction",
                WallPaper: "Wallpapers",
                LockScreen: "LockScreen",
                WebFilter: "WebContent",
                AppRestriction: "AppsRestrictions",
                HomeScreenLayout: "HomeScreenLayout",
                Cert: "Certificate",
                CustomConfig: "CustomConfig",
                Media: "Book",
                ADDomain: "ADDomain",
                ADCertificate: "ADCertificate",
                SystemExtension: "SystemExtension",
                KernelExtension: "KernelExtension",
                RecoveryLock: "RecoveryLock",
                PrivacyPreference: "PrivacyPreference",
                DeviceMode: "DeviceMode",
                LDAP: "LDAP",
                HttpProxy: "HttpProxy",
                DNSSetting: "DNSSetting",
                LoginItem: "LoginItem",
                MacSecurity: "MacSecurity",
                MacLoginWindow: "MacLoginWindow",
                Vpn: "Vpn",
                MacWallpaper: "MacWallpaper",
                MacDiskManagement: "MacDiskManagement",
                MacTimeMachine: "MacTimeMachine",
                AirPrint: "AirPrint",
                Energy: "Energy",
                Dock: "Dock",
            },
            isCustom: false,
            selectWeek: 0,
            dayList: [],
            worshipDays: [],
            configFileType: "Default",
        }
    }
    Init() {
        this.getList();
        // this.getDeviceAll();
        getTemplateTabs().then(c => {
            this.setState({ templateTabs: c })
        });
        console.log("statessss",this.props.history.location.state);
        if (this.props.history.location.state && Object.keys(this.props.history.location.state).length > 0) {
            this.operationClick({key: 'edit'}, this.props.history.location.state);
        }
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }
    // getDeviceAll() {

    //     getAllDevices({ pageIndex: 1, pageSize: 999999, platform: "IOS" }).then(res => {
    //         this.setState({ devicesList: res.dataList })
    //     });
    // }
    deviceHandleChange(value: any[]) {
        this.setState({ selectDevices: value });
    }
    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search,
            category: "Common"
        }
        getTemplateList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }
    templateNameUpdate = (e: any) => {
        console.log(e);
        var sele = {
            name: e.target.value,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            brand: this.state.selectRow.brand,
            status: this.state.selectRow.status,
            category: "Common"
        }
        this.setState({ selectRow: sele })
    }
    // addDevicesForTemplateClick() {
    //     this.setState({ loading: true })
    //     addDeviceForTemplate(this.state.selectRow.id, { deviceIds: this.state.selectDevices }).then(c => {
    //         notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
    //         this.setState({ showAddDeviceForTemplate: false, selectDevices: [], loading: false })

    //     })
    // }
    // templateNameClick = (key: string) => {
    //     if (key == "edit") {
    //         this.setState({ showRightBox: true })
    //     }

    // }
    handleMenuClick = (e: any) => {
        var currname = "";
        switch (e.key) {
            // case "Applications":
            //     currname = "应用";
            //     break;
            case "Book":
                currname = "Book";
                break;
            case "Webclip":
                currname = "Web Clip";
                break;
            case "Password":
                currname = "密码";
                break;
            case "KioskMode":
                currname = "应用规则";
                break;
            case "DeviceMode":
                currname = "设备模式";
                break;
            case "Network":
                currname = "WiFi";
                break;
            case "Wallpapers":
                currname = "墙纸";
                break;
            case "LockScreen":
                currname = "锁屏";
                break;
            case "restriction":
                currname = "限制";
                break;
            case "WebContent":
                currname = "网页浏览"
                break;
            case "AppsRestrictions":
                currname = "应用限制"
                break;
            case "HomeScreenLayout":
                currname = "主屏布局"
                break;
            case "Certificate":
                currname = "证书"
                break;
            case "CustomConfig":
                currname = "自定义配置"
                break;
            case "ADDomain":
                currname = "AD Domain"
                break;
            case "ADCertificate":
                currname = "AD Certificate"
                break;
            case "SystemExtension":
                currname = "System Extension"
                break;
            case "KernelExtension":
                currname = "Kernel Extension"
                break;
            case "RecoveryLock":
                currname = "Recovery Lock"
                break;
            case "PrivacyPreference":
                currname = "Privacy Preferences"
                break;
            case "LDAP":
                currname = "LDAP"
                break;
            case "HttpProxy":
                currname = "全局HTTP代理"
                break;
            case "DNSSetting":
                currname = "DNS设置"
                break;
            case "LoginItem":
                currname = "管理登录项"
                break;
            case "MacSecurity":
                currname = "安全"
                break;
            case "MacLoginWindow":
                currname = "登录界面"
                break;
            case "Vpn":
                currname = "VPN"
                break;
            case "MacWallpaper":
                currname = "桌面壁纸"
                break;
            case "MacDiskManagement":
                currname = "磁盘存储"
                break;
            case "MacTimeMachine":
                currname = "时间机器"
                break;            
            case "AirPrint":
                currname = "隔空打印"
                break;
            case "Energy":
                currname = "电源节能"
                break;
            case "Dock":
                currname = "Dock栏"
                break;
        }
        this.setState({ current: e.key, currentName: currname });
    };
    onSearch = () => {
        this.getList();

    }
    // updateItemStatus = (e: any, row: any) => {
    //     row.status = e;
    //     addTemplate(row).then(c => {
    //         this.getList();
    //     })

    // }
    subTemplateNameClick() {
        var sele = {
            name: this.state.selectRow.name,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            brand :this.state.selectRow.brand,
            status: this.state.selectRow.status,
            category: "Common"
        }
        addTemplate(sele).then(c => {
            this.getList();
            this.setState({ showRightBox: false })
        })
    }
    addTemplateClick = () => {
        this.setState({ loading: true });
        this.formRef.current?.validateFields().then(
            (res) => {
                res.status = "Active";
                res.isCustomized = this.state.isCustom;
                res.executionRules = [];
                res.category = "Common";
                // if (this.state.isCustom) {
                if (this.state.configFileType === "Schedule") {
                    var i = 0;
                    for (i; i < this.state.dayList.length; i++) {
                        var item = this.state.dayList[i];
                        if (item.times.length > 0) {
                            var durations: any[] = [];
                            item.times.forEach((time: any) => {
                                durations.push({
                                    startTime: time[0].format('HH:mm'),
                                    endTime: time[1].format('HH:mm')
                                })
                            });
                            res.executionRules.push({
                                worshipDay: item.worshipDay,
                                durations: durations
                            });
                        }
                    }
                    if (res.executionRules.length === 0) {
                        notification.warning({message: <Translation>{t => {return t("定时模式下时间不能为空")}}</Translation>});
                        this.setState({ loading: false })
                        return
                    }
                }
                console.log("addTemplate",res)
                addTemplate(res).then(
                    () => {
                        this.getList();
                        this.setState({ isShowAddForm: false });
                        this.formRef.current?.resetFields();
                        notification.success({message: <Translation>{t => {return `${this.state.isModify ? t("编辑配置文件成功") : t("添加配置文件成功")}`}}</Translation>});
                    },
                    () => { notification.error({message: <Translation>{t => {return `${this.state.isModify ? t("编辑配置文件失败") : t("添加配置文件失败")}`}}</Translation>}) }
                ).finally(
                    () => { 
                        this.setState({
                            loading: false, 
                            isModify: false, 
                            configFileType: "Default", 
                            isCustom: false,
                            dayList: [],
                            selectWeek: 0,
                            worshipDays: []
                        }) 
                    }
                )
            },
            () => { this.setState({loading: false}) }
        )
    }
    operationClick = (e: any, row: any) => {
        if (!e.key) {
            return
        }
        switch (e.key) {
            case "edit":
                var obj = (row.platform === "IOS" && row.type === "Schedule") ? {current: "Book", name: "Book"} : (row.platform === "macOS" && row.type === "Schedule") ? {current: "restriction", name: "限制"} : {current: "restriction", name: "限制"};
                this.formRef.current?.setFieldsValue(row);
                this.setState({ 
                    isShowTable: false, 
                    currentName: obj.name, 
                    current: obj.current,
                    selectRow: row
                });
                this.getSelectedTemplate(row.id);
                this.getList();
                break;
            case "delete":
                deleteTemplate(row.id).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> }) }
                )
                break;
            case "copy":
                copyTemplates({id: row.id, name: `${row.name}_拷贝`}).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("拷贝成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("拷贝失败")}}</Translation> }) }
                )
                break;
            case "modify":
                getTemplate(row.id).then(
                    res => {
                        this.formRef.current?.setFieldsValue(row);
                        var worshipDays: any[] = [];
                        var dayList = res.executionRules ? res.executionRules.map((item: any) => {
                            worshipDays.push(item.worshipDay);
                            item["times"] = item.durations.map((duration: any) => {
                                var starArr = duration.startTime.split(":");
                                var endArr = duration.endTime.split(":");
                                var startTime = dayjs().hour(parseInt(starArr[0])).minute(parseInt(starArr[1]));
                                var endTime = dayjs().hour(parseInt(endArr[0])).minute(parseInt(endArr[1]));
                                return [startTime, endTime];
                            });
                            return item;
                        }) : [];
                        this.setState({
                            isModify: true, 
                            isShowAddForm: true, 
                            configFileType: res.type,
                            isCustom: res.isCustomized,
                            platform:row.platform,
                            dayList: dayList,
                            worshipDays: worshipDays
                        });
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("获取配置文件失败")}}</Translation>})
                    }
                )
                break;
            case "devices":
                this.props.history.push({
                    pathname: `/home/profiles/devices/${row.id}`, 
                    state: row
                });
                break;
        
            default:
                break;
        }
    }
    onClose = () => {
        this.setState({
            showRightBox: false,
        });
    };
    getTemplateTab = () => {
        var tab = this.state.templateTabs.find(c => {
            return c.tabKey === this.state.current;
        })
        return tab;

    }

    getSelectedTemplate = (templateId: string) => {
        this.setState({ isSelectdItem: false });
        getTemplate(templateId).then(
            (res) => {
                const {selectdItemList} = res;
                const {templateSelectItemsMap} = this.state;
                const items: any = {};
                if (selectdItemList.length > 0) {
                    console.log(selectdItemList);
                    var selectedItem = selectdItemList[0];
                    if(selectdItemList.includes("Restriction"))
                    {
                        selectedItem = "Restriction";
                    }
                    
                    var current = templateSelectItemsMap[selectedItem]
                    this.setState({ isSelectdItem: true,current: current });
                    selectdItemList.forEach((item: any) => {
                        items[item] = true;
                    })
                }
                this.setState({templateItemsStatus: items});
                
            },
            () => { notification.error({message: <Translation>{t => {return t("获取模板数据失败")}}</Translation>}) }
        )
    }

    updateTemplate = () => {
        this.getSelectedTemplate(this.state.selectRow.id);   
    }

    getCurret = () => {
        var item = this.state.dayList?.find(c => {
            return c.worshipDay === this.state.selectWeek;
        })
        return item;
    }

    addTimeClick = () => {
        var item = this.getCurret();
        if (item) {
            var startTime = dayjs().hour(0).minute(0);
            if (item.times.length !== 0) {
                startTime = item.times[item.times.length - 1][1]
            }
            var endTime;
            if (startTime.hour() === 23) {
                endTime = dayjs().hour(23).minute(59);
            } else {
                endTime = dayjs().hour(startTime.hour() + 1).minute(0);
            }
            item.times.push([startTime, endTime])
            this.setState({dayList: [...this.state.dayList]});
        } else {
            var startTime = dayjs().hour(0).minute(0);
            var endTimee = dayjs().hour(1).minute(0);
            item = {
                times: [],
                worshipDay: this.state.selectWeek
            };
            item.times.push([startTime, endTimee]);
            this.setState({dayList: [...this.state.dayList, item]});
        }
    }

    timeChange = (value: any, index: number) => {
        var currentDay = this.getCurret();
        currentDay.times[index] = value
        if (currentDay.times.length !== (index + 1)) {
            if (currentDay.times[index + 1][1].hour() <= value[1].hour() && currentDay.times[index + 1][1].minute() < value[1].minute()) {
                currentDay.times.splice(index + 1, currentDay.times.length - index - 1)
            }
        }
        this.setState({dayList: [...this.state.dayList]});
    }
    deleteTime = (index: number) => {
        var item = this.getCurret();
        item.times.splice(index, 1);
        this.setState({dayList: [...this.state.dayList]});
    }

    getWeedTimeShow = () => {
        var item = this.getCurret();
        if (item) {
            return (item?.times?.map((item: any, index: number) => (
                <Col key={index} span={24}>
                    <Row>
                        <Col span={18}>
                            <TimePicker.RangePicker value={item}
                                format={"HH:mm"}
                                minuteStep={1}
                                hideDisabledOptions={true}
                                onChange={(e) => { this.timeChange(e, index) }} 
                            />
                        </Col>
                        <Col span={5} offset={1}>
                            <Button type="primary" danger shape="circle" icon={<DeleteOutlined />} size="small"
                                onClick={() => { this.deleteTime(index) }}
                            />
                        </Col>
                    </Row>
                </Col>
            )))
        } else {
            return "";
        }
    }

    selectTypeChange(key: boolean) {
        this.setState({isCustom: key});
        if (!key) {
            for (var i = 0; i < this.state.dayList.length; i++) {
                this.state.dayList[i] = Object.assign({}, this.state.dayList[this.state.selectWeek])
            }
            this.setState({dayList: [...this.state.dayList]});
        }
    }

    render() {
        const { 
            name, current, selectTemplate, isShowTable, templateItemsStatus, 
            templateItemsMap, data, pageIndex, pageSize, totalCount, search, 
            loading, isShowAddForm, selectRow, showRightBox, 
            selectDevices, currentName, dropdownVisible, isModify, 
            isCustom, selectWeek, configFileType, worshipDays, isSelectdItem,platform
        } = this.state;
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>  
                                        <a onClick={() => {
                                            this.setState({ 
                                                isShowTable: true, 
                                                currentName: "", 
                                                current: "",
                                                templateItemsStatus: {
                                                    App: false,
                                                    WebClip: false,
                                                    Password: false,
                                                    MultiAppsMode: false,
                                                    WiFi: false,
                                                    Restriction: false,
                                                    WallPaper: false,
                                                    LockScreen: false,
                                                    WebFilter: false,
                                                    AppRestriction: false,
                                                    HomeScreenLayout: false,
                                                    Cert: false,
                                                    CustomConfig: false,
                                                    Media: false,
                                                    DeviceMode: false
                                                }, 
                                            });
                                            this.props.history.replace("/home/profiles/index");
                                        }}>{t("全部配置文件")}</a>
                                    </Breadcrumb.Item>
                                    {currentName?.trim() ? <Breadcrumb.Item>{t(currentName)}</Breadcrumb.Item> : null}
                                </Breadcrumb>
                                {!currentName && (
                                    <Row style={{padding: "32px 0 11px 0"}}>
                                        <Space>
                                            <img src="/images/profileIcon.svg" alt="" />
                                            <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("配置文件")}</span>
                                        </Space>
                                    </Row>
                                )}
                            </div>
                            <Row style={{ width: "100%" }}>
                                {!isShowTable && (
                                    <div className="borderBox">
                                        <Row style={{height: "36px", borderBottom: "1px solid #F1F1F1"}}>
                                            <Col span={4} style={{textAlign: "center", marginTop: "-3px"}}>
                                                {(selectRow.platform === 'IOS' || selectRow.platform === 'macOS') && (
                                                    <AppleFilled style={{fontSize: 20}}></AppleFilled>
                                                )}
                                                {(selectRow.platform === 'Android') && (
                                                    <AndroidFilled style={{fontSize: 20}}></AndroidFilled>
                                                )}
                                                <span style={{
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    marginLeft: "10px",
                                                }}>{selectRow.name}</span>
                                                {selectRow.brand != "Default" && (<Tag style={{marginLeft:16}} color="#87d068">{selectRow.brand}</Tag>)}
                                            </Col>
                                            <Col span={20}>
                                                <NavLink style={{marginLeft: "16px"}} to={{
                                                    pathname: `/home/profiles/devices/${selectRow.id}`, 
                                                    state: selectRow, 
                                                }}>
                                                    <img src="../../images/App.png" style={{marginTop: "-3px"}} alt="" />
                                                    <span>{t("关联设备")}</span>
                                                </NavLink>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={4}>
                                                <Menu mode="inline" defaultSelectedKeys={['Book']} defaultOpenKeys={['Book']}
                                                    onClick={this.handleMenuClick} selectedKeys={[current]}
                                                >
                                                    {/* {(!["IOS", "macOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule")) && (<Menu.Item key="Applications" disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Applications"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("应用")}</span> 
                                                            {templateItemsStatus[templateItemsMap["Applications"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)} */}
                                                    {(selectRow.platform === "IOS" || selectRow.platform === "macOS") && (<Menu.Item key="Book"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Book"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("Book")}</span> 
                                                            {templateItemsStatus[templateItemsMap["Book"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)}
                                                    {(selectRow.platform !== "macOS" && (selectRow.platform !== "IOS" || (selectRow.platform === "IOS" && selectRow.type !== "Schedule"))) && (<Menu.Item key="Webclip"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Webclip"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>Web Clip</span> 
                                                            {templateItemsStatus[templateItemsMap["Webclip"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)}
                                                    {((!["IOS", "macOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule"  )) && selectRow.brand != "Oppo") && (<Menu.Item key="Password"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Password"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("密码")}</span> 
                                                            {templateItemsStatus[templateItemsMap["Password"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)}
                                                    {(selectRow.platform !== "macOS") && <Menu.Item key="KioskMode"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["KioskMode"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("应用规则")}</span> 
                                                            {templateItemsStatus[templateItemsMap["KioskMode"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>}
                                                    {(["IOS"].includes(selectRow.platform) && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="DeviceMode"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["DeviceMode"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("设备模式")}</span> 
                                                                {templateItemsStatus[templateItemsMap["DeviceMode"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(!["Android", "IOS", "macOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule")) && (
                                                        <Menu.Item key="Network"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Network"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>WiFi</span> 
                                                                {templateItemsStatus[templateItemsMap["Network"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    <Menu.Item key="restriction"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["restriction"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("限制")}</span> 
                                                            {templateItemsStatus[templateItemsMap["restriction"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>
                                                     {(["IOS","macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule") && (<>
                                                        <Menu.Item key="Vpn"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Vpn"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("VPN")}</span> 
                                                                {templateItemsStatus[templateItemsMap["Vpn"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="AirPrint"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["AirPrint"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("隔空打印")}</span> 
                                                                {templateItemsStatus[templateItemsMap["AirPrint"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    </>)}
                                                    {(selectRow.platform === "macOS") && (<>
                                                        <Menu.Item key="PrivacyPreference"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["PrivacyPreference"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("Privacy Preferences")}</span> 
                                                                {templateItemsStatus[templateItemsMap["PrivacyPreference"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="MacSecurity"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["MacSecurity"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("安全")}</span> 
                                                                {templateItemsStatus[templateItemsMap["MacSecurity"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="MacTimeMachine"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["MacTimeMachine"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("时间机器")}</span> 
                                                                {templateItemsStatus[templateItemsMap["MacTimeMachine"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="ADDomain"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["ADDomain"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("AD Domain")}</span> 
                                                                {templateItemsStatus[templateItemsMap["ADDomain"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="ADCertificate"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["ADCertificate"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("AD Certificate")}</span> 
                                                                {templateItemsStatus[templateItemsMap["ADCertificate"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="MacDiskManagement"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["MacDiskManagement"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("Disk Management")}</span> 
                                                                {templateItemsStatus[templateItemsMap["MacDiskManagement"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="LoginItem"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["LoginItem"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("管理登录项")}</span> 
                                                                {templateItemsStatus[templateItemsMap["LoginItem"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="RecoveryLock"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["RecoveryLock"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("Recovery Lock")}</span> 
                                                                {templateItemsStatus[templateItemsMap["RecoveryLock"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="SystemExtension"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["SystemExtension"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("System Extension")}</span> 
                                                                {templateItemsStatus[templateItemsMap["SystemExtension"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item key="KernelExtension"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["KernelExtension"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("Kernel Extension")}</span> 
                                                                {templateItemsStatus[templateItemsMap["KernelExtension"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    </>)}
                                                    {(!["IOS", "macOS"].includes(selectRow.platform) || (selectRow.platform === "IOS" && selectRow.type !== "Schedule")) && (<Menu.Item key="Wallpapers"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Wallpapers"]]}>
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("墙纸")}</span> 
                                                            {templateItemsStatus[templateItemsMap["Wallpapers"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)}
                                                    {(!["Android", "macOS", "IOS"].includes(selectRow.platform) || (selectRow.platform === "IOS" && selectRow.type !== "Schedule")) && (
                                                        <Menu.Item key="LockScreen"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["LockScreen"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("锁屏")}</span> 
                                                                {templateItemsStatus[templateItemsMap["LockScreen"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}

                                                    {["IOS","Android"].includes(selectRow.platform) && (
                                                        <Menu.Item key="WebContent"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["WebContent"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("网页浏览")}</span> 
                                                                {templateItemsStatus[templateItemsMap["WebContent"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(selectRow.platform === "macOS" && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="MacWallpaper"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["MacWallpaper"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("桌面壁纸")}</span> 
                                                                {templateItemsStatus[templateItemsMap["MacWallpaper"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(selectRow.platform === "macOS" && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="Dock"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Dock"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("Dock栏")}</span> 
                                                                {templateItemsStatus[templateItemsMap["Dock"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(selectRow.platform === "macOS" && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="Energy"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Energy"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("电源节能")}</span> 
                                                                {templateItemsStatus[templateItemsMap["Energy"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(selectRow.platform === "macOS" && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="MacLoginWindow"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["MacLoginWindow"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("登录界面")}</span> 
                                                                {templateItemsStatus[templateItemsMap["MacLoginWindow"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {/* {selectRow.platform !== "macOS" && (<Menu.Item key="WebContent">
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("网页浏览")}</span> 
                                                            {templateItemsStatus[templateItemsMap["WebContent"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)} */}
                                                    {/* {(selectRow.platform !== "macOS" && selectRow.platform !== "IOS") && (
                                                        <Menu.Item key="AppsRestrictions">
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("应用限制")}</span> 
                                                                {templateItemsStatus[templateItemsMap["AppsRestrictions"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )} */}
                                                    {(!["Android", "macOS", "IOS"].includes(selectRow.platform) || (selectRow.platform === "IOS" && selectRow.type !== "Schedule")) && (
                                                        <Menu.Item key="HomeScreenLayout"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["HomeScreenLayout"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("主屏布局")}</span> 
                                                                {templateItemsStatus[templateItemsMap["HomeScreenLayout"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(!["Android", "macOS", "IOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule")) && (
                                                        <Menu.Item key="Certificate"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["Certificate"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("证书")}</span> 
                                                                {templateItemsStatus[templateItemsMap["Certificate"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(!["Android", "macOS", "IOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule")) && (
                                                        <Menu.Item key="CustomConfig"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["CustomConfig"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("自定义配置")}</span> 
                                                                {templateItemsStatus[templateItemsMap["CustomConfig"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(["IOS"].includes(selectRow.platform) && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="LDAP"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["LDAP"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("LDAP")}</span> 
                                                                {templateItemsStatus[templateItemsMap["LDAP"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(["IOS"].includes(selectRow.platform) && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="HttpProxy"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["HttpProxy"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("全局HTTP代理")}</span> 
                                                                {templateItemsStatus[templateItemsMap["HttpProxy"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                    {(["IOS","macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule") && (
                                                        <Menu.Item key="DNSSetting"  disabled={isSelectdItem && !templateItemsStatus[templateItemsMap["DNSSetting"]]}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <span>{t("DNS设置")}</span> 
                                                                {templateItemsStatus[templateItemsMap["DNSSetting"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                            </div>
                                                        </Menu.Item>
                                                    )}
                                                </Menu>
                                            </Col>
                                            <Col span={20}>
                                                {/* {current === "Applications" && (
                                                    <TemplateContentApp templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentApp>
                                                )} */}
                                                {current === "Book" && (
                                                    <TemplateContentBook templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentBook>
                                                )}
                                                {current === "Webclip" && (
                                                    <TemplateContentWebClip templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentWebClip>
                                                )}
                                                {current === "Password" && (
                                                    <TemplateContentPassword templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate} brand={selectRow.brand}></TemplateContentPassword>
                                                )}
                                                {current === "KioskMode" && (
                                                    <TemplateContentSingleApp templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate} brand={selectRow.brand}></TemplateContentSingleApp>
                                                )}
                                                {current === "DeviceMode" && (
                                                    <TemplateDeviceMode templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateDeviceMode>
                                                )}
                                                {current === "Wallpapers" && (
                                                    <TemplateContentWallpaper templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentWallpaper>
                                                )}
                                                {current === "LockScreen" && (
                                                    <TemplateContentLock templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentLock>
                                                )}
                                                {current === "Network" && (
                                                    <TemplateContentWifi templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentWifi>
                                                )}
                                                {current === "restriction" && (
                                                    <TemplateContentRestriction templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentRestriction>
                                                )}
                                                {current === "PrivacyPreference" && (
                                                    <TemplatePrivacyPreferences templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplatePrivacyPreferences>
                                                )}
                                                {current === "ADDomain" && (
                                                    <TemplateContentADDomain templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentADDomain>
                                                )}
                                                {current === "ADCertificate" && (
                                                    <TemplateContentADCertificate templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentADCertificate>
                                                )}
                                                {current === "LoginItem" && (
                                                    <TemplateContentLoginItem templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentLoginItem>
                                                )}
                                                {current === "RecoveryLock" && (
                                                    <TemplateContentRecoveryLock templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentRecoveryLock>
                                                )}
                                                {current === "SystemExtension" && (
                                                    <TemplateContentSystemExtension templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentSystemExtension>
                                                )}
                                                {current === "KernelExtension" && (
                                                    <TemplateContentKernelExtension templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentKernelExtension>
                                                )}
                                                {current === "WebContent" && (
                                                    <TemplateContentBrowse templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentBrowse>
                                                )}
                                                {current === "AppsRestrictions" && (
                                                    <TemplateAppRestriction templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateAppRestriction>
                                                )}
                                                {/* {current === "HomeScreenLayout" && (
                                                    <TimplateScreenLayout templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TimplateScreenLayout>
                                                )} */}
                                                {current === "HomeScreenLayout" && (
                                                    <HomeScreenLayout templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></HomeScreenLayout>
                                                )}
                                                {current === "Certificate" && (
                                                    <TemplateContentCertificate templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentCertificate>
                                                )}
                                                {current === "CustomConfig" && (
                                                    <TemplateContentCustomConfig templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentCustomConfig>
                                                )}
                                                {current === "LDAP" && (
                                                    <TemplateContentLDAP templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentLDAP>
                                                )}
                                                {current === "HttpProxy" && (
                                                    <TemplateContentHttpProxy templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentHttpProxy>
                                                )}
                                                {current === "DNSSetting" && (
                                                    <TemplateContentDNSSetting templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentDNSSetting>
                                                )}
                                                {current === "MacSecurity" && (
                                                    <TemplateConentSecurity templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateConentSecurity>
                                                )}
                                                {current === "MacLoginWindow" && (
                                                    <TemplateConentLoginWindow templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateConentLoginWindow>
                                                )}
                                                {current === "Vpn" && (
                                                    <TemplateContentVpn templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentVpn>
                                                )}                                                
                                                {current === "MacWallpaper" && (
                                                    <TemplateContentMacWallpaper templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentMacWallpaper>
                                                )}
                                                {current === "MacDiskManagement" && (
                                                    <TemplateContentMacDiskManagement templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentMacDiskManagement>
                                                )} 
                                                {current === "MacTimeMachine" && (
                                                    <TemplateContentMacTimeMachine templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentMacTimeMachine>
                                                )}
                                                {current === "AirPrint" && (
                                                    <TemplateContentAirPrint templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentAirPrint>
                                                )}           
                                                {current === "Energy" && (
                                                    <TemplateContentEnergySaver templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentEnergySaver>
                                                )}
                                                {current === "Dock" && (
                                                    <TemplateContentDock templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentDock>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                {isShowTable && (
                                    <>
                                        <div className="borderBox">
                                            <Row  className="mb-3">
                                                <Col > 
                                                {t("配置文件名称")}:
                                                <Input placeholder="" value={search}
                                                style={{ width: "200px", marginLeft: 10 }}
                                                    onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.onSearch(); gaEvent("docs", "onClick", "onSearch") }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row>
                                                <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                    onClick={() => { this.setState({ isShowAddForm: true }) }}><PlusOutlined />{t("添加")} {t("配置文件")}</Button></Col>
                                            </Row>
                                            <Row  >
                                                <Col span={24}>
                                                    <Table 
                                                        size="middle" 
                                                        dataSource={data} 
                                                        rowKey={recored => recored.id} 
                                                        style={{ width: "100%", minHeight: 300 }} 
                                                        pagination={false}
                                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                    >
                                                        <Column
                                                            title={t("配置文件名称")}
                                                            key="name"
                                                            dataIndex="name"
                                                        ></Column>
                                                        <Column
                                                            title={t("配置文件类型")}
                                                            key="type"
                                                            dataIndex="type"
                                                            render={(v: any) => {
                                                                return v === "Default" ? t("长效") : v === "Schedule" ? t("定时") : v
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("平台")}
                                                            key="platform"
                                                            dataIndex="platform"
                                                            render={(v: any) =>{
                                                                return (
                                                                <div >
                                                                {v==="Android"&&(
                                                                    <span><AndroidFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;Android</span>
                                                                )}
                                                                {v==="IOS"&&(
                                                                    <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;iOS</span>
                                                                )}
                                                                {v==="macOS"&&(
                                                                    <span><img src="/images/macLogo.png" alt="" />&nbsp;&nbsp;macOS</span>
                                                                )}
                                                                </div>)
                                                                }}
                                                        ></Column>
                                                        {/* <Column title="创建人" key="model" dataIndex="model"></Column> */}

                                                        <Column
                                                            title={t("创建时间")}
                                                            key="createTime"
                                                            dataIndex="createTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("最近修改时间")}
                                                            key="updateTime"
                                                            dataIndex="updateTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("关联设备")}
                                                            key="deviceCount"
                                                            dataIndex="deviceCount"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/profiles/devices/${row.id}`, state: row }} >{v}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        {/* <Column
                                                        title="状态"
                                                        key="status"
                                                        dataIndex="status"
                                                        render={(v, row, index) => {
                                                            return (
                                                                <Select value={v} onChange={(e) => this.updateItemStatus(e, row)}>
                                                                    <Select.Option value="Draft">草稿</Select.Option>
                                                                    <Select.Option value="Active">发布</Select.Option>
                                                                </Select>)
                                                        }}
                                                    ></Column> */}
                                                        <Column
                                                            title={t("操作")}
                                                            key="id"
                                                            dataIndex="id"
                                                            align="center"
                                                            render={(v, raw, index) => {
                                                                return (
                                                                    <Dropdown
                                                                        open={dropdownVisible.length > 0 && dropdownVisible[index]['value']}
                                                                        onOpenChange={(visible) => {
                                                                            const tempList: any[] = [];
                                                                            dropdownVisible.forEach((item) => {
                                                                                if (item.key === v) {
                                                                                    item['value'] = visible;
                                                                                }
                                                                                tempList.push(item);
                                                                            })
                                                                            this.setState({dropdownVisible: tempList});
                                                                        }}
                                                                        // trigger={['click']}
                                                                        dropdownRender={() => (
                                                                            <Menu onClick={(res) => this.operationClick(res, raw)}>
                                                                                <Menu.Item key='edit'>{t("编辑明细")}</Menu.Item>
                                                                                <Menu.Item key='modify'>{t("基本信息")}</Menu.Item>
                                                                                <Menu.Item key='devices'>{t("关联设备")}</Menu.Item>
                                                                                <Popconfirm title={"确认删除?"} onConfirm={() => this.operationClick({key: 'delete'}, raw)}>
                                                                                    <Menu.Item key='delete' className="custom-menu-item">{t("删除")}</Menu.Item>
                                                                                </Popconfirm>
                                                                                <Menu.Item key='copy'>{t("拷贝")}</Menu.Item>
                                                                            </Menu>
                                                                        )}>
                                                                        <a>{t("更多")}<DownOutlined /></a>
                                                                    </Dropdown>
                                                                )
                                                            }}></Column>
                                                    </Table>
                                                    <Pagination
                                                        style={{ textAlign: "right", marginTop: "20px" }}
                                                        pageSize={pageSize}
                                                        current={pageIndex}
                                                        total={totalCount}
                                                        showTotal={(total, range) =>
                                                            `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                        }
                                                        onChange={(page, pageSize) => {
                                                            this.getList(page, pageSize);
                                                        }}
                                                        onShowSizeChange={(current, size) => this.getList(current, size)}
                                                    ></Pagination>
                                                </Col>
                                            </Row>
                                            <Modal
                                                confirmLoading={loading}
                                                maskClosable={false}
                                                open={isShowAddForm}
                                                destroyOnClose={true}
                                                title={`${isModify ? "" : t("添加")} ${t("配置文件")}`}
                                                forceRender={true}
                                                width={"650px"}
                                                onOk={() => { this.addTemplateClick() }}
                                                onCancel={() => {
                                                    this.setState({ 
                                                        isShowAddForm: false,
                                                        isModify: false, 
                                                        loading: false,
                                                        configFileType: "Default",
                                                        isCustom: false,
                                                        dayList: [],
                                                        selectWeek: 0,
                                                        worshipDays: []
                                                    });
                                                    this.formRef.current?.resetFields();
                                                }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Form
                                                    // labelCol={{ span: 6 }}
                                                    ref={this.formRef}
                                                    layout="vertical"
                                                    initialValues={{ name: "", platform: "IOS", status: "Draft", type: "Default" ,showOverview:false}}
                                                >
                                                    <Item label="ID" name="id" hidden>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("配置文件名称")} name="name" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("平台")} name="platform" rules={[{ required: true }]}>
                                                        <Select disabled={isModify}  onChange={(e)=>{this.setState({platform:e})}}>
                                                            <Select.Option value="IOS">iOS</Select.Option>
                                                            <Select.Option value="Android">{t("安卓")}</Select.Option>
                                                            <Select.Option value="macOS">macOS</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    {platform =="Android" && (<Item label={t("品牌")} name="brand" rules={[{ required: true }]}>
                                                        <Select disabled={isModify} defaultValue={"Default"}>
                                                            <Select.Option value="Default">{t("通用")}</Select.Option>
                                                            <Select.Option value="Vivo">{t("Vivo")}</Select.Option>
                                                            <Select.Option value="HONOR">{t("HONOR")}</Select.Option>
                                                            <Select.Option value="Oppo">{t("Oppo")}</Select.Option>
                                                        </Select>
                                                    </Item>)}
                                                    <Item label={t("配置文件类型")} name="type" rules={[{ required: true }]}>
                                                        <Select disabled={isModify} onChange={(value: string) => { this.setState({configFileType: value}) }}>
                                                            <Select.Option value="Default">{t("长效")}</Select.Option>
                                                            <Select.Option value="Schedule">{t("定时")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={t("在主页图表显示")} name="showOverview" rules={[{ required: true }]}>
                                                        <Select  onChange={(value: string) => { this.setState({configFileType: value}) }}>
                                                            <Select.Option value={false}>{t("不显示")}</Select.Option>
                                                            <Select.Option value={true}>{t("显示")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    {configFileType === "Schedule" && (
                                                        <>
                                                            <Row style={{ width: "100%", margin: 10, marginLeft: -20 }}>
                                                                <Col span={4} style={{ textAlign: "center" }}>{t("模式")}:</Col>
                                                                <Col span={12}>
                                                                    <Radio.Group buttonStyle="solid" value={isCustom} onChange={(e) => {
                                                                        if (e.target.value) {
                                                                            this.setState({selectWeek: 0});
                                                                        }
                                                                        this.selectTypeChange(e.target.value);
                                                                        this.setState({
                                                                            dayList: [],
                                                                            selectWeek: 0,
                                                                            worshipDays: []
                                                                        });
                                                                    }} >
                                                                        <Radio.Button value={true} >{t("自定义")}</Radio.Button>
                                                                        <Radio.Button value={false}>{t("每天")}</Radio.Button>
                                                                    </Radio.Group>
                                                                </Col>
                                                            </Row>
                                                            {isCustom && (
                                                                <Row style={{ width: "100%", margin: 10, marginLeft: -20 }}>
                                                                    <Col span={4} style={{ textAlign: "center" }}>{t("星期")}:</Col>
                                                                    <Col span={18}>
                                                                        <Radio.Group buttonStyle="solid" value={selectWeek} onChange={(e) => { this.setState({selectWeek: e.target.value}) }} >
                                                                            <Radio.Button style={{color: selectWeek === 0 ? "#fff" : worshipDays.includes(0) ? "#1890FF" : ""}} value={0}>{t("星期天")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 1 ? "#fff" : worshipDays.includes(1) ? "#1890FF" : ""}} value={1}>{t("星期一")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 2 ? "#fff" : worshipDays.includes(2) ? "#1890FF" : ""}} value={2}>{t("星期二")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 3 ? "#fff" : worshipDays.includes(3) ? "#1890FF" : ""}} value={3}>{t("星期三")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 4 ? "#fff" : worshipDays.includes(4) ? "#1890FF" : ""}} value={4}>{t("星期四")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 5 ? "#fff" : worshipDays.includes(5) ? "#1890FF" : ""}} value={5}>{t("星期五")}</Radio.Button>
                                                                            <Radio.Button style={{color: selectWeek === 6 ? "#fff" : worshipDays.includes(6) ? "#1890FF" : ""}} value={6}>{t("星期六")}</Radio.Button>
                                                                        </Radio.Group>
                                                                    </Col>
                                                                </Row>

                                                            )}
                                                            <Row style={{ width: "100%", marginLeft: -20 }}>
                                                                <Col span={4} style={{ textAlign: "center" }}>{t("时间")}:</Col>
                                                                <Col span={18}>
                                                                    <Row gutter={[16, 16]}>
                                                                        { this.getWeedTimeShow() }
                                                                    </Row>
                                                                    <Row style={{ marginTop: 16 }}>
                                                                        <Button type="dashed" onClick={() => { this.addTimeClick() }} block>
                                                                            {t("添加时间")}
                                                                        </Button>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )} 
                                                    {/* <Item label="状态" name="status" rules={[{ required: true }]}>
                                                    <Select>
                                                        <Select.Option value="Draft">草稿</Select.Option>
                                                        <Select.Option value="Active">发布</Select.Option>
                                                    </Select>
                                                </Item> */}
                                                </Form>
                                            </Modal>
                                        </div>
                                    </>
                                )}
                            </Row>
                            <Drawer
                                title="编辑配置文件"
                                placement="right"
                                closable={true}
                                onClose={this.onClose}
                                open={showRightBox}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                                            取消
                                        </Button>
                                        <Button onClick={() => { this.subTemplateNameClick() }} type="primary">
                                            提交
                                        </Button>
                                    </div>
                                }
                            >
                                <Row>
                                    <Col span={6}>名称</Col>
                                </Row>
                                <Row>
                                    <Col span={24}><Input value={selectRow?.name} onChange={this.templateNameUpdate}></Input></Col>
                                </Row>

                            </Drawer>
                            {/* <Modal
                                confirmLoading={loading}
                                maskClosable={false}
                                visible={showAddDeviceForTemplate}
                                title="关联设备"
                                width={"650px"}

                                onOk={() => this.addDevicesForTemplateClick()}
                                onCancel={() => this.setState({ showAddDeviceForTemplate: false })}>
                                <Select
                                    mode="multiple"
                                    showArrow
                                    value={selectDevices}
                                    onChange={(values: any[]) => {
                                        this.setState({ selectDevices: values })
                                    }}
                                    style={{ width: '100%' }}>
                                    {
                                        devicesList?.map(item => (
                                            <Select.Option key={item.id} value={item.id} label={item.model}>{item.model}</Select.Option >
                                        ))
                                    }
                                </Select>

                            </Modal> */}
                        </div>)
                    );
                }}</Translation>)
        );
    }
}
export default connect(mapStatetoProps, {})(TemplateIndex);